import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const JobMaster = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchjobDetails();
    dispatch(updateNavbarHeading("Job Title Master"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [jobmaster, setJobMaster] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    IsInActive: 0,
  });

  const columns = {
    Name: { text: "Name", align: "start", visible: true },
    Description: { text: "Description", visible: true },
    IsInActive: { text: "Active", align: "center", visible: true },
  };
  const defaultColumns = {
    Name: true,
    Description: true,
    IsInActive: true,
  };

  const [modalName, setModalName] = useState("");

  const handleEdit = async (id) => {
    setModalName("Edit");
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}job-title-masters/${id.ID}`
      );

      if (response.status === 200) {
        const depData = response?.data?.data;

        if (depData) {
          const { Name, Description, IsInActive } = depData;
          // Update form data with fetched values, including IsGroup
          setFormData({
            id: id.ID,
            Name: Name || "",
            Description: Description || "",
            IsInActive: IsInActive === 1 ? 1 : 0,
          });
        }
      } else {
        console.error(
          "Failed to fetch Technology details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Technology details:", error);
    }
  };

  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchjobDetails = async () => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(`${API_URL}job-title-masters`);
      if (response?.status === 200) {
        setApiStatus(response?.status);
        const data = response?.data?.data;
        setJobMaster(data);
        const allNames = data.map((item) => item.Name);
        setSuggestions(allNames);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === "Name") {
      // Filter suggestions that match input
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Description: "",
      IsInActive: 0,
    });
    setIsEditMode(false);
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name) newErrors.Name = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (event) => {
  event.preventDefault();
  
  if (validateForm()) {
    const method = isEditMode ? "put" : "post";
    const apiUrl = isEditMode
      ? `${API_URL}job-title-masters/${formData.id}`
      : `${API_URL}job-title-masters`;

    try {
      const response = await PostServiceCaller(apiUrl, formData, method);
      
      // Check if the response indicates success
      if (response && (response.status === "success" || response.status === 200 || response.statusCode === 200)) {
        const successMessage = method === "post" 
          ? "Form submitted successfully!" 
          : "Form updated successfully!";
        toast.success(successMessage);
        resetFormState();
        fetchjobDetails();
        setIsEditMode(false);
        setShowModal(false);
      } else {
        // Show API's error message if it exists
        const errorMessage = response?.message || response?.data?.message;
        console.error("API error:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("There was an error submitting the form data!", error);
      // Handle network errors and API error responses
      const errorMessage = error.response?.data?.message 
        || error.message 
        || "Error submitting form data.";
      toast.error(errorMessage);
    }
  }
};


  useEffect(() => {
    const handleClickOutside = (event) => {
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );
      const inputElement = document.getElementById("Name");
      if (showSuggestions && suggestionsElement && !suggestionsElement.contains(event.target) && inputElement !== event.target) {
        setShowSuggestions(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, showSuggestions]);
  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
    setShowSuggestions(false);
    setFilteredSuggestions([]);
  };

  const handleAddForm = () => {
    setModalName("Add");
    resetFormState();
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={jobmaster}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >{`${modalName} Job Title`}</p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      onClick={handleEditModalClose}
                    ></i>
                  </span>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div class="mb-3">
                          <label for="Name" class="form-label">
                            Name<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Name ? "is-invalid" : ""
                            }`}
                            id="Name"
                            aria-describedby="Name"
                            name="Name"
                            placeholder="Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                            autocomplete="off"
                          />
                          {showSuggestions &&
                            filteredSuggestions.length > 0 && (
                              <div
                                className="suggestions-container"
                                style={{
                                  position: "absolute",
                                  width: "93%",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  backgroundColor: "#fff",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  zIndex: 1000,
                                  marginTop: "2px",
                                }}
                              >
                                <div
                                  style={{
                                    padding: "8px 12px",
                                    fontSize: "0.8rem",
                                    color: "#666",
                                    borderBottom: "1px solid #eee",
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  Existing matching Job Titles:
                                </div>
                                <ul
                                  style={{
                                    listStyle: "none",
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  {filteredSuggestions.map(
                                    (suggestion, index) => (
                                      <li
                                        key={index}
                                        style={{
                                          padding: "8px 12px",
                                          fontSize: "0.9rem",
                                          borderBottom: "1px solid #eee",
                                          color: "#333",
                                          cursor: "default", // Disable pointer cursor
                                        }}
                                      >
                                        {suggestion}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}
                          {errors.Name && (
                            <div className="invalid-feedback">
                              {errors.Name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div class="mb-3">
                          <label for="Description" class="form-label">
                            Description
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            id="Description"
                            aria-describedby="Description"
                            name="Description"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-sm-3">
                            <label
                              htmlFor="flexSwitchCheckChecked"
                              className="form-label me-2"
                            >
                              Active
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="IsInActive"
                              id="flexSwitchCheckChecked"
                              checked={formData.IsInActive === 1}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-end">
                      <button
                        className="cancel-btn me-2"
                        onClick={handleEditModalClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="custom-btn">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default JobMaster;
